import { createSlice, Dispatch } from "@reduxjs/toolkit";
import { getUsersByQuery } from "../../services/user/userService";
import type { UsersState } from "../../types/state/stateTypes";

export const usersSlice = createSlice({
  name: "users",

  initialState: {
    allAdUsers: [],
    adUsers: [],
    isLoadingUsers: false,
  } as UsersState,

  reducers: {
    setAllUsers: (state, action) => {
      state.allAdUsers = action.payload;
    },
    setUsers: (state, action) => {
      state.adUsers = action.payload;
    },
    setIsLoadingUsers: (state, action) => {
      state.isLoadingUsers = action.payload;
    },
  },
});

export const fetchUsersByQuery =
  (query?: string, limit?: number) => async (dispatch: Dispatch) => {
    try {
      dispatch(usersSlice.actions.setIsLoadingUsers(true));
      const users = await getUsersByQuery(query, limit);
      dispatch(usersSlice.actions.setUsers(users));
    } finally {
      dispatch(usersSlice.actions.setIsLoadingUsers(false));
    }
  };

export const fetchAllUsers = () => async (dispatch: Dispatch) => {
  try {
    dispatch(usersSlice.actions.setIsLoadingUsers(true));

    const users = await getUsersByQuery("", 2000);

    dispatch(usersSlice.actions.setAllUsers(users));
    dispatch(usersSlice.actions.setUsers(users));
  } finally {
    dispatch(usersSlice.actions.setIsLoadingUsers(false));
  }
};

export const thunks = {
  fetchUsersByQuery,
  fetchAllUsers,
};

export const actions = {
  ...usersSlice.actions,
};
